module.exports = [{"type":"title","text":"2025-07-09"},{"type":"normal","text":"","style":{"font-weight":"bold"},"children":[{"type":"html","text":"U本位永續合約：‘賬戶餘額和倉位更新推送’移除SNAPSHOT類型。"}]}]


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/changelog/2025-07-09.json
// module id = k7fq
// module chunks = 3